import { Component, ElementRef, Injector, Input, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * Picture Widget
 */
@Component({
  selector: 'picture-widget',
  templateUrl: './picture-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './picture-widget.component.scss']
})
export class PictureWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Initial widget height
   */
  widgetHeight = 500;//default

  /**
  * Constructor
  * @param componentEl ElementRef
  */
  constructor(injector: Injector, private componentEl: ElementRef) {
    super(injector, 'picture', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    //little different approach than in other widgets because we have to deal with pictureTypeId

    this.widgetService.loadReflist('ref_property_imagetype').pipe(first()).subscribe((data: Array<any>) => {
      this.reflists['ref_property_imagetype'] = data.filter(o => o.oid !== 0);

      this.availableLayouts = this.reflists.ref_property_imagetype.map(o => o.description);

      this.initWidgetConfig();
    });
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('picture');

    this.currentLayout = this.widgetConfig.widgetSettings.currentLayout;
    //layouts in sidebar are chosen from widgetConfig.widgetSettings.availableLayouts so set them
    this.widgetConfig.widgetSettings.availableLayouts = this.availableLayouts;

    const pictureTypeId: number = this.reflists['ref_property_imagetype'].find(o => o.description === this.currentLayout).oid;

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.loadForType(pictureTypeId);
  }

  /**
   * Load picture for given typeId
   * @param pictureTypeId {number} Picture type Id
   */
  loadForType(pictureTypeId: number) {
    const reportId = this.getReport() || 0;
    return this.widgetService.loadFromWidgetResource(`picture?id=${reportId}&pictureTypeId=${pictureTypeId}`);
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    const setting = this.widgetConfig.widgetSettings;
    setting.currentLayout = setting.currentLayout || this.reflists.ref_property_imagetype.find(o => o.oid = data.pictureTypeId);
    this.currentLayout = setting.currentLayout;

    setTimeout(() => this.widgetResized());

    return data;
  }

  /**
   * CSS class for current layout
   */
  get layoutCssClass(): string {
    return `image-layout-${this.currentLayout.toLowerCase()}`;
  }

  /**
   * Layout changed event handler
  * @param newLayout {string} New layout
   */
  layoutChanged(_newLayout: string) {
    const layout = this.currentLayout;
    this.widgetConfig.widgetSettings.currentLayout = layout;
    const pictureTypeId = this.reflists['ref_property_imagetype'].find(o => o.description === layout).oid;

    if (!this.mockup) {
      this.loadForType(pictureTypeId).pipe(first()).subscribe(data => {
        this.widgetData = this.preprocessLoadedData(data);
      });
    } else {
      this.widgetData.pictureDescription = `${layout} description`;
    }
  }

  /**
   * widgetResized event handler
   */
  protected widgetResized() {
    setTimeout(() => {
      const el = this.componentEl.nativeElement;
      this.widgetHeight = el.closest('.gridster-item').offsetHeight;
    }, 10);
  }

}
